<template>
  <b-card no-body>
    <template v-if="!reportParams.id_users">
      <b-card-body>
        <b-form-group
          label="Temsilci Arama"
          label-for="keyword"
        >
          <b-input-group>
            <b-form-input
              id="keyword"
              v-model="searchKeyword.keyword"
              placeholder="Temsilci Adı..."
              @keydown.enter="searchData"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="searchData"
              >
                <FeatherIcon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-card-body>
      <b-table
        v-if="dataList.length > 0"
        class="mb-0"
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(company)="data">
          <div>{{ data.item.name }}</div>
          <div class="font-small-3 text-primary">
            {{ data.item.user_type }}
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <b-button
              variant="primary"
              size="sm"
              @click="setUser(data.item.id)"
            >
              Görüntüle
            </b-button>
          </div>
        </template>
      </b-table>
      <b-card-footer v-if="dataCounts > perPage">
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </template>
    <template v-else>
      <b-card-body>
        <b-row>
          <b-col>
            <div class="font-weight-bold text-primary">
              Temsilci
            </div>
            <div class="font-weight-light">
              {{ user.name }}
            </div>
          </b-col>
          <b-col>
            <div class="font-weight-bold text-primary">
              E-Posta
            </div>
            <div class="font-weight-light">
              {{ user.email }}
            </div>
          </b-col>
          <b-col
            cols="12"
            md="auto"
          >
            <b-button
              variant="flat-danger"
              pill
              @click="resetData"
            >
              <FeatherIcon icon="RepeatIcon" /> Temsilci Değiştir
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </template>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BTable, BCardFooter, BPagination, BRow, BCol,
} from 'bootstrap-vue'

export default {
  name: 'UserSearch',
  components: {
    BPagination,
    BCardFooter,
    BCard,
    BCardBody,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BRow,
    BCol,
  },
  props: {
    getReport: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'name',
          label: 'ADI SOYADI',
        },
        {
          key: 'email',
          label: 'E-POSTA',
          thClass: 'width-200',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100',
        },
      ],
      dataQuery: {
        select: [
          'users.id AS id',
          'users.name AS name',
          'users.email AS email',
          'user_types.title AS user_type',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['users/getUsers']
    },
    dataCounts() {
      return this.$store.getters['users/getUsersCount']
    },
    searchKeyword() {
      return this.$store.getters['users/search']
    },
    reportParams() {
      return this.$store.getters['reportUsers/reportParams']
    },
    user() {
      return this.$store.getters['users/getUser']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.resetData()
  },
  methods: {
    searchData() {
      if (this.searchKeyword.keyword) {
        this.dataQuery.or_like = {
          'users.name': this.searchKeyword.keyword,
        }
        this.getDataList()
      } else {
        this.dataQuery.or_like = {}
        this.$store.commit('users/USERS_LIST', [])
        this.$store.commit('users/USERS_COUNT', 0)
      }
    },
    getDataList() {
      this.$store.dispatch('users/usersList', this.dataQuery)
    },
    setUser(id) {
      this.reportParams.id_users = id
      this.$store.dispatch('users/userView', id)
      this.getReport()
    },
    resetData() {
      this.searchKeyword.keyword = null
      this.$store.commit('users/USERS_LIST', [])
      this.$store.commit('users/USERS_COUNT', 0)
      this.reportParams.id_users = 0
    },
  },
}
</script>
